import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { getConversationLabelColor } from "../../../../utils/chat-util";
import getAvatarUrl from "../../../../utils/get-avatar-url";

const acknowledgeAthlete = (e, athlete) => {
  e.preventDefault();
  submit("/actions/refresh", {
    method: "GET",
    body: {
      "modal[type]": "acknowledge-athlete",
      acknowledgeAthlete: athlete._id,
    },
  });
};

const UnacknowledgedAthlete = ({ athlete, activeUser }) => {
  const { t } = useTranslation("coaching-portal");
  const referAsClients = Boolean(activeUser.referAsClients);
  const role = referAsClients
    ? t("athletes.roleClientLower")
    : t("athletes.roleAthleteLower");
  const badgeLabel = athlete.isGymMember ? "PRESS" : "PULL";
  const badgeColor = getConversationLabelColor(badgeLabel);
  return (
    <article className="unacknowledged">
      <div className="relative">
        <div
          className="press-label"
          style={{
            border: `1px solid ${badgeColor.color}`,
            color: badgeColor.color,
            backgroundColor: badgeColor.background,
            top: 0,
          }}
        >
          {badgeLabel}
        </div>
        <div
          className="avatar"
          style={{
            backgroundImage: `url(${getAvatarUrl(
              athlete,
              true,
              activeUser.webAppTheme
            )})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            height: 60,
            width: 60,
            flexShrink: 0,
            marginTop: 0,
            borderRadius: "100%",
          }}
        ></div>
        <div className="athlete-details">
          <p className="s1">{athlete.name || athlete.email}</p>
          {athlete.email && <p className="p6">{athlete.email}</p>}
        </div>
      </div>

      <footer>
        <button
          data-button-type="primary"
          onClick={(e) => acknowledgeAthlete(e, athlete)}
          type="button"
          data-icon
          className="w-full"
        >
          <span>
            {t("athletes.unacknowledgedAthlete.acknowledge", { role })}
          </span>
          <SvgIcon
            src="/img/new-icons/arrow-forward.svg"
            noFilterOnLight={true}
          />
        </button>
      </footer>
    </article>
  );
};

export default UnacknowledgedAthlete;
